<app-header></app-header>

<mat-toolbar class="app-toolbar" color="primary"> </mat-toolbar>

<div class="main-content cf-flex-column cf-justify-content-space-around cf-align-items-center">
  <div class="error-message">
    <div class="mat-headline-6">{{ 'UI.GeneralError.Title' | translate }}</div>
    <p>{{ 'UI.GeneralError.Message' | translate }}</p>
  </div>

  <button mat-stroked-button data-test="ToHomepageButton" color="primary" (click)="navigateToHomepage()">
    {{ 'UI.Common.Action.GoToHomepage' | translate }}
  </button>
</div>
